jQuery('.card-hov').mouseenter(function () {
      jQuery(this).find(".noshowx").fadeOut(500);
        jQuery(this).find('.noshow').fadeIn(500);
     });

 jQuery('.card-hov').mouseleave(function () {
   jQuery(this).find(".noshow").fadeOut();
        jQuery(this).find('.noshowx').fadeIn();
      
     }
 ).mouseleave();



if ($(window).width() < 767)
    {
setTimeout(function () {
	 var style = document.createElement( 'style' )
style.innerHTML = '.afterpay-paragraph { font-size: 10px; } .afterpay-logo.type-badge svg, .afterpay-logo.type-badge {height: calc(30/104*var(--logo-badge-width,80px));width: 66px;}'
document.querySelector('#placement-afterpay_on_site_messaging_payments_messaging_aQG3w9').shadowRoot.appendChild( style )
}, 2000);
    }









 $.fn.toggleAttr = function(attr, val) {
    var test = $(this).attr(attr);
    if ( test ) { 
      // if attrib exists with ANY value, still remove it
      $(this).removeAttr(attr);
    } else {
      $(this).attr(attr, val);
    }
    return this;
  };
$(".head_loc details").click(function(){
    $(this).attr("open", function(_, attr){
                    return attr ? null : "open";})
})